import { bl_inv_bin_reservation_gen_doc_link_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class BinReservationGenDocLinkContainer extends BaseContainerModel {
  bl_inv_bin_reservation_gen_doc_link: bl_inv_bin_reservation_gen_doc_link_RowClass
    = new bl_inv_bin_reservation_gen_doc_link_RowClass();
}